export default {
      id: "image-placeholder-usage",
      viewBox: "0 0 15 13",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#image-placeholder",
      toString: function () {
        return this.url;
      }
    }